import { useSelector } from '@algoan/dashboard/store/store';
import { accessTokenPayloadSelector } from '@algoan/dashboard/store/selectors';

export const useActivityPageAccessControl = (): boolean => {
  const accessTokenPayload = useSelector(accessTokenPayloadSelector);
  const resourceAccessTable =
    accessTokenPayload?.resource_access && accessTokenPayload.resource_access['analysis-manager'];
  const hasHistoryReaderRole = resourceAccessTable?.roles.includes('history-reader');

  return !!hasHistoryReaderRole;
};
